export default __webpack_public_path__ + "images/6E.65af932.png";